import { Thumbnail } from './Thumbnail';
export { Thumbnail };
